module.exports = __webpack_public_path__ + "manifest.json?21396f6d40fb6feef56d8ac80c4e4329";


//////////////////
// WEBPACK FOOTER
// ./client/static/manifest.json
// module id = 109
// module chunks = 0